import React, { Component } from "react";
import {
    Container,
    Box,
    Typography,
    Card,
    CardContent,
    Button,
    Link as MuiLink
} from '@mui/material';
import { listByGroup } from "./apiForum";
import { Link } from "react-router-dom";
import { stateToHTML } from 'draft-js-export-html';
import { convertFromRaw } from 'draft-js'

class ForumPosts extends Component {
    
    constructor() {
        super();
        this.state = {
            forumposts: [],
            page: 1
        };
    }

     loadPosts = (groupId, page) => {
        listByGroup(groupId, page).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({ forumposts: data });
            }
        });
    };

    componentDidMount() {     
        this.loadPosts(this.props.groupId , this.state.page);
    }

    loadMore = number => {
        this.setState({ page: this.state.page + number });
        this.loadPosts(this.props.groupId, this.state.page + number);
    };

    loadLess = number => {
        this.setState({ page: this.state.page - number });
        this.loadPosts(this.props.groupId, this.state.page - number);
    };

    convertFromJSONToHTML = (text) => {
        try{
        return { __html: stateToHTML(convertFromRaw(text))}
        } catch(exp) {
        console.log(exp)
        return { __html: 'Error' }
        }
        }

    renderForumPosts = forumposts => {
        return (
            <Box>
                {forumposts.map((forumpost, i) => {
                    const forumposterId = forumpost.forumpostedBy
                        ? `/user/${forumpost.forumpostedBy._id}`
                        : "";
                    const forumposterName = forumpost.forumpostedBy
                        ? forumpost.forumpostedBy.name
                        : " Unknown";

                    return (
                        <Card key={i} sx={{ mb: 2, width: '100%' }}>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>
                                    {forumpost.title}
                                </Typography>

                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontStyle: 'italic',
                                        backgroundColor: '#fff3cd',
                                        p: 1,
                                        borderRadius: 1
                                    }}
                                >
                                    Posted by{" "}
                                    <MuiLink
                                        component={Link}
                                        to={`${forumposterId}`}
                                        underline="hover"
                                    >
                                        {forumposterName}
                                    </MuiLink>
                                    {" "}on {new Date(forumpost.created).toDateString()}
                                </Typography>

                                <Button
                                    component={Link}
                                    to={`/forumpost/${forumpost._id}`}
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    sx={{ mt: 2 }}
                                >
                                    Read more
                                </Button>
                            </CardContent>
                        </Card>
                   );
                })}
            </Box>
        );
    };

    render() {
        const { forumposts, page } = this.state;
        return (
            <Container>
                <Typography variant="h5" sx={{ mt: 5, mb: 5 }}>
                    {!forumposts.length ? "No more posts!" : forumposts.length + " posts"}
                </Typography>

                {this.renderForumPosts(forumposts)}

                <Box sx={{ mt: 5, mb: 5, display: 'flex', gap: 2 }}>
                    {page > 1 && (
                        <Button
                            variant="contained"
                            color="warning"
                            onClick={() => this.loadLess(1)}
                        >
                            Previous ({page - 1})
                        </Button>
                    )}

                    {forumposts.length > 1 && (
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => this.loadMore(1)}
                        >
                            Next ({page + 1})
                        </Button>
                    )}
                </Box>
            </Container>
        );
    }
}

export default ForumPosts;